var _circle, _circle2, _path, _g, _path2, _path3, _path4, _path5, _path6, _ellipse, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 39.9997,
    r: 39.5349,
    fill: "url(#paint0_linear_17195_156776)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 39.9997,
    r: 39.226,
    stroke: "url(#paint1_linear_17195_156776)",
    strokeOpacity: 0.6,
    strokeWidth: 0.617733
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6519 29.2051C53.2328 28.9737 55.8283 29.4383 58.1753 30.5527C60.5223 31.6672 62.5376 33.3916 64.0161 35.5518C65.4946 37.7121 66.3837 40.2315 66.5923 42.8535C66.7916 45.358 66.3632 47.8709 65.3501 50.1592C65.218 50.4578 65.1947 50.8004 65.3022 51.1191L66.9253 55.9248C67.056 56.3121 66.693 56.6853 66.3022 56.5654L62.4585 55.3857C62.0248 55.2527 61.5635 55.3593 61.2251 55.6387C61.1019 55.7404 60.9766 55.8399 60.8501 55.9375L60.4663 56.2236C57.2962 58.5082 53.3631 59.4247 49.5288 58.7734C45.7041 58.1237 42.2867 55.9661 40.0229 52.7705C40.0167 52.7597 40.0106 52.7485 40.0034 52.7383C38.4933 50.6018 37.5672 48.0979 37.3188 45.4805C37.0704 42.862 37.5094 40.2233 38.5913 37.833C39.6732 35.4429 41.359 33.3862 43.4771 31.8711C45.5952 30.356 48.0708 29.4365 50.6519 29.2051ZM40.0601 52.8545C40.0661 52.8736 40.0707 52.8932 40.0737 52.9131L40.0776 52.9727C40.0776 52.9517 40.0759 52.9307 40.0728 52.9102L40.0601 52.8545Z",
    fill: "url(#paint2_linear_17195_156776)",
    stroke: "url(#paint3_linear_17195_156776)",
    strokeWidth: 0.793736
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17195_156776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0947 46.5741C42.6313 50.0709 38.903 52.4334 34.7269 53.1438C30.5509 53.8542 26.2677 52.8546 22.8163 50.364C22.5261 50.1566 22.2435 49.9385 21.9691 49.7101C21.7269 49.5086 21.4005 49.4355 21.0995 49.5285L16.9003 50.8258C16.2003 51.0421 15.5497 50.3747 15.7836 49.6805L17.5446 44.4532C17.6187 44.2334 17.6038 43.994 17.5098 43.7821C16.401 41.2835 15.932 38.5388 16.1493 35.8033C16.3763 32.9473 17.3433 30.2031 18.9522 27.8492C20.5611 25.4952 22.7547 23.6153 25.3103 22.4002C27.8659 21.185 30.6926 20.6779 33.5036 20.9303C36.3146 21.1827 39.0098 22.1857 41.3158 23.8373C43.6217 25.489 45.4563 27.7306 46.6334 30.3347C47.8104 32.9388 48.2881 35.8127 48.0178 38.6648C47.7476 41.5169 46.7391 44.2456 45.0947 46.5741Z",
    fill: "url(#paint4_linear_17195_156776)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4393 34.8666H23.7279L22.8167 39.5248H21.5281L22.4393 34.8666Z",
    fill: "#111928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.099 39.618C25.6217 39.618 25.1921 39.5159 24.8103 39.3119C24.4328 39.1034 24.1356 38.815 23.9186 38.4468C23.7017 38.0786 23.5932 37.6615 23.5932 37.1957C23.5932 36.7299 23.7017 36.3129 23.9186 35.9446C24.1356 35.5764 24.4328 35.2903 24.8103 35.0862C25.1921 34.8777 25.6217 34.7734 26.099 34.7734C26.5155 34.7734 26.8908 34.8489 27.2249 34.9997C27.559 35.1505 27.8367 35.3679 28.058 35.6518L27.2379 36.4105C26.9429 36.0467 26.5849 35.8648 26.164 35.8648C25.9167 35.8648 25.6954 35.9202 25.5002 36.0312C25.3093 36.1421 25.1596 36.2996 25.0511 36.5036C24.947 36.7033 24.8949 36.934 24.8949 37.1957C24.8949 37.4575 24.947 37.6904 25.0511 37.8944C25.1596 38.0941 25.3093 38.2494 25.5002 38.3603C25.6954 38.4712 25.9167 38.5266 26.164 38.5266C26.5849 38.5266 26.9429 38.3447 27.2379 37.981L28.058 38.7396C27.8367 39.0235 27.559 39.2409 27.2249 39.3917C26.8908 39.5426 26.5155 39.618 26.099 39.618Z",
    fill: "#111928"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3072 34.8666H29.5958V38.48H31.7696V39.5248H28.3072V34.8666Z",
    fill: "#111928"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9832 39.618C33.3063 39.618 32.7791 39.4294 32.4017 39.0523C32.0285 38.6753 31.8419 38.1407 31.8419 37.4486V34.8666H33.1306V37.4087C33.1306 38.154 33.4191 38.5266 33.9962 38.5266C34.569 38.5266 34.8553 38.154 34.8553 37.4087V34.8666H36.1245V37.4486C36.1245 38.1407 35.9357 38.6753 35.5583 39.0523C35.1851 39.4294 34.6601 39.618 33.9832 39.618Z",
    fill: "#111928"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0174 37.0959C40.2778 37.1891 40.4817 37.3355 40.6292 37.5351C40.7768 37.7303 40.8505 37.9676 40.8505 38.2471C40.8505 38.6553 40.69 38.9703 40.3689 39.1921C40.0478 39.4139 39.5835 39.5248 38.9761 39.5248H36.5419V34.8666H38.8459C39.4273 34.8666 39.8699 34.9775 40.1736 35.1993C40.4774 35.4167 40.6292 35.7117 40.6292 36.0844C40.6292 36.3062 40.575 36.5059 40.4665 36.6833C40.3624 36.8563 40.2127 36.9939 40.0174 37.0959ZM37.8175 35.8182V36.7166H38.7027C39.1366 36.7166 39.3535 36.5657 39.3535 36.2641C39.3535 35.9668 39.1366 35.8182 38.7027 35.8182H37.8175ZM38.8979 38.5732C39.3492 38.5732 39.5748 38.4157 39.5748 38.1007C39.5748 37.7858 39.3492 37.6283 38.8979 37.6283H37.8175V38.5732H38.8979Z",
    fill: "#111928"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.0848,
    cy: 34.2402,
    rx: 1.03891,
    ry: 1.03512,
    fill: "#0063F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17195_156776",
    x: 0.0394268,
    y: 5.17151,
    width: 63.7476,
    height: 63.8914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.84784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.929412 0 0 0 0 1 0 0 0 0 0.419608 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17195_156776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17195_156776",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17195_156776",
    x1: 41.5,
    y1: 0.464844,
    x2: 41.5,
    y2: 79.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17195_156776",
    x1: 41.5,
    y1: 0.464844,
    x2: 41.5,
    y2: 79.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17195_156776",
    x1: 52.3579,
    y1: 28.75,
    x2: 60.0682,
    y2: 62.9422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17195_156776",
    x1: 80.0092,
    y1: 71.0609,
    x2: 46.2589,
    y2: 64.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17195_156776",
    x1: 31.6573,
    y1: 20.8672,
    x2: 31.6573,
    y2: 53.3672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FF26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b5fdd7bab2618d22165a1b0f2a959533.svg";
export { ForwardRef as ReactComponent };